import styled from 'styled-components'

import theme from '../../theme'

export interface ISegmentedControlContainerProps {
  itemWidth?: string | number
  itemHeight?: string | number
}

const SegmentedControlContainer = styled.span<ISegmentedControlContainerProps>`
  .segmented * {
    border-radius: 100px !important;
  }
  .segmented label {
    min-width: 164px;
    width: ${(p) => p.itemWidth ?? '120px'};
    height: ${(p) => p.itemHeight ?? '36px'};
    .ant-segmented-item-label {
      line-height: ${(p) => p.itemHeight ?? '36px'};
      padding: 0 16px !important;
    }
  }
  .segmented > div {
    background: ${theme.colors.gray4};
    border-color: ${theme.colors.gray4};
  }
  .segmented label input + div {
    font-size: 14px !important;
    color: ${theme.colors.gray8};
  }
  .segmented label input:checked + div {
    font-weight: 600;
    font-size: 14px;
    color: ${theme.colors.gray9};
  }
`

export { SegmentedControlContainer }
